<div class="menu-container debug">
  <div class="line">
    <label>
      <input tabclick type="checkbox" [checked]="settingsManager.settings.debugRightClick"
        (change)="settingsManager.toggle('debugRightClick')">
      <span [ghs-label]="'settings.debug.rightClick'"></span>
    </label>
  </div>
  <div class="separator"></div>
  <div class="line">
    <label>
      <input tabclick type="checkbox" [checked]="settingsManager.settings.logServerMessages"
        (change)="settingsManager.toggle('logServerMessages')">
      <span [ghs-label]="'settings.debug.logServerMessages'"></span>
    </label>
  </div>
  <div class="line ping">
    <label class="label"><span [ghs-label]="'server.ping'"></span></label>
    <input type="number" #serverPing [value]="settingsManager.settings.serverPing || '0'" (keyup)="0"
      (change)="setServerPing($event)" [ghs-label]="'server.ping'" [ghs-label-attribute]="'placeholder'">
  </div>
  <div class="separator"></div>
  <div class="line">
    <a tabclick (click)="clearFeedbackErrors()"><span [ghs-label]="'settings.feedbackErrors.clear'"></span></a>
  </div>
  <div class="line title span">
    <label><span [ghs-label]="'editor'"></span></label>
  </div>
  <div class="line">
    <a tabclick [routerLink]="'/editor/monster'"><span [ghs-label]="'editor.monster'"></span></a>
  </div>
  <div class="line">
    <a tabclick [routerLink]="'/editor/character'"><span [ghs-label]="'editor.character'"></span></a>
  </div>
  <div class="line">
    <a tabclick [routerLink]="'/editor/deck'"><span [ghs-label]="'editor.deck'"></span></a>
  </div>
  <div class="line">
    <a tabclick [routerLink]="'/editor/edition'"><span [ghs-label]="'editor.edition'"></span></a>
  </div>
  <div class="line title span">
    <label><span [ghs-label]="'tools'"></span></label>
  </div>
  <div class="line">
    <a tabclick [routerLink]="'/tools/decks'"><span [ghs-label]="'tools.decks'"></span></a>
  </div>
  <div class="line">
    <a tabclick [routerLink]="'/tools/attackmodifier'"><span [ghs-label]="'tools.attackModifier'"></span></a>
  </div>
  <div class="separator"></div>
  <div class="line">
    <a tabclick (click)="settingsManager.validateEditionData()"><span
        [ghs-label]="'tools.validateEditionData'"></span></a>
  </div>
  <div class="separator"></div>
  <div class="line">
    <a tabclick [routerLink]="'/'"><span [ghs-label]="'tools.backToGhs'"></span></a>
  </div>
</div>